import { DarePlatform, Platform } from 'root/src/shared/@types/platforms';
import { SocialPlatform } from 'root/src/server/util/awsClients/authApiClient.types';
export function getReadablePlatform(platform) {
    switch (platform) {
        case Platform.Twitch:
            return 'Twitch';
        case Platform.TikTok:
            return 'TikTok';
        case Platform.YouTube:
            return 'YouTube';
        default:
            return undefined;
    }
}
export function getReadableDarePlatform(darePlatform) {
    switch (darePlatform) {
        case DarePlatform.Twitch:
            return 'Twitch';
        case DarePlatform.TikTok:
            return 'TikTok';
        case DarePlatform.YouTube:
            return 'YouTube';
        case DarePlatform.YouTubeShorts:
            return 'YouTube Shorts';
        case DarePlatform.X:
            return 'X';
        default:
            return undefined;
    }
}
export function getReadableViewershipPlatform(darePlatform) {
    switch (darePlatform) {
        case DarePlatform.Twitch:
            return 'Twitch';
        case DarePlatform.TikTok:
            return 'TikTok';
        case DarePlatform.YouTube:
            return 'YouTube Videos';
        case DarePlatform.YouTubeShorts:
            return 'YouTube Shorts';
        default:
            return undefined;
    }
}
export function getReadableSocialPlatform(socialPlatform) {
    switch (socialPlatform) {
        case SocialPlatform.Steam:
            return 'Steam';
        default:
            return undefined;
    }
}
